import React from "react";
import SelectProgress from "../../selectProgress/SelectProgress";
import "../../../styles/components/selectbook/NikkiWrapper.scss";
import { getLocalizedAssetPath } from "../../../utils/getLocalizedLogo";

export default function NikkiWrapper({
  titleDescription,
  progressValue,
  onNext,
  onPrev,
  onNextSound,
  onPrevSound,
  showNext = true,
  showPrev = false,
  children,
}) {
  return (
    <div className="niki-wrap">
      <div className="niki-title">
        <figure>
          <img src="/images/makingBranch/niki-title.svg" alt="title bg" />
        </figure>
        <p>{titleDescription}</p>
      </div>
      <div className="niki-inner">
        <SelectProgress value={progressValue} />
        {children}
        <div className="btns">
          {showPrev && (
            <figure onClick={onPrev} className="niki-prev">
              <img src={getLocalizedAssetPath("/images/makingBranch/prev-btn.svg")} alt="이전으로" />
            </figure>
          )}
          {showNext && (
            <figure onClick={onNext} className="niki-next">
              <img src={getLocalizedAssetPath("/images/makingBranch/next-btn.svg")} alt="다음으로" />
            </figure>
          )}
        </div>
      </div>
      <figure className="niki-bottom">
        <img src="/images/makingBranch/niki-bottom.svg" alt="bottom asset" />
      </figure>
      <figure className="custom-niki">
        <img src="/images/makingBranch/niki.svg" alt="niki asset" />
      </figure>
    </div>
  );
}
